/**
 * @enum {string}
 */
var _ol_layer_Property_ = {
  OPACITY: 'opacity',
  VISIBLE: 'visible',
  EXTENT: 'extent',
  Z_INDEX: 'zIndex',
  MAX_RESOLUTION: 'maxResolution',
  MIN_RESOLUTION: 'minResolution',
  SOURCE: 'source'
};

export default _ol_layer_Property_;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ol/layer/property.js
// module id = 610
// module chunks = 0